import React, { useEffect } from "react";
import { FilterListProps } from "./FilterListProps";


const FilterList: React.FC<FilterListProps> = ({
    className,
    columnName1,
    columnName2,
    elements,
    selectedElements,
    onClick
}) => {    
    return(
        <React.Fragment>
            <div className={`${className}`}>
                <div className="table-container">
                    <table className="filterTable">
                        <thead>
                            <tr>
                                <th>{columnName1}</th>
                                <th>{columnName2}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {elements.map((element, index) => {
                                return(
                                    <tr key={index} onClick={() => onClick(element.id)} className={`hover:cursor-pointer ${selectedElements.some(x => x === element.id) ? "bg-custom-600" : "bg-custom-400"}`}>
                                        <td>{element.element1}</td>
                                        <td>{element.element2}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </React.Fragment>
    )
}

export default FilterList;